
import { getCourseChapter, getCoursesDetail } from "@/api/home";
import { mapGetters } from "vuex";
import LoadMore from 'vux/src/components/load-more/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
LoadMore,
XDialog,
XButton
},
props: {
sellType: {
default: "",
type: String
},
getCourseChapterData: {
default: {},
type: Object
}
},
data() {
return {
loading: false,
noData: false,
imgList: {
play: require("@/common/image/course/play.png"),
playActive: require("@/common/image/learn/playActive.png"),
down: require("@/common/image/learn/down.png"),
up: require("@/common/image/learn/up.png")
},
allShow: true,
oneShow: false,
showOper: false,
comeForm: "",
courseid: 0,
chapterList: [],
courseLink: "",
linkShow: false,
workShow: false,
dialog: {
width: "70%",
margin: "auto"
},
workContent: "",
packageChapter: []
};
},
computed: {
...mapGetters(["user"]),
showStudy() {
if (this.comeForm === "LearnDetail") {
return true;
} else {
return false;
}
}
},
methods: {

putUp(val, index) {
delete val.oneShow;
delete val.allShow;
this.$set(val, "oneShow", true);


},

putDown(val, index) {
delete val.oneShow;
delete val.allShow;
this.$set(val, "allShow", true);
},

downloadWare(val) {
console.log(val);
this.courseLink = val.courseware;
this.linkShow = true;
},
closeLink() {
this.linkShow = false;
},

finishWork() {
this.workShow = true;
},
closeWork() {
this.workShow = false;
},

initChapter() {
this.loading = true;
let dt = {};
if (!this.user || !this.user.id) {
dt = {
courseid: this.courseid
};
} else {
dt = {
courseid: this.courseid,
userid: this.user.id
};
}
getCourseChapter(dt).then(res => {
this.loading = false;
this.chapterList = res.entity.courseKpoints;
this.chapterList = this.chapterList.map(item => {
return {
...item,
allShow: true
};
});
});
},
playerVideo(val) {
this.$emit("playerVideo", val);
},
playStudy(val) {
this.$emit("playStudy", val);
if (!this.showStudy) return;
this.workContent = val.assignment;
if (val.oper) {
return;
} else {
this.chapterList = this.chapterList.map(item => {
item.childKpoints.forEach(m => {
if (m.oper) delete m.oper;
});
return item;
});
this.$set(val, "oper", true);

}
}

},
mounted() {
this.comeForm = this.$route.name;
this.courseid = this.$route.query.courseid;


if(this.chapterList.length == 0&&this.getCourseChapterData){

this.chapterList = this.getCourseChapterData.courseKpoints;
this.chapterList = this.chapterList.map(item => {
return {
...item,
allShow: true
};
});
}
},
watch: {
getCourseChapterData(newVal, oldVal){
console.log(newVal, oldVal)
this.chapterList = this.getCourseChapterData.courseKpoints;
this.chapterList = this.chapterList.map(item => {
return {
...item,
allShow: true
};
});

}
}
};



// WEBPACK FOOTER //
// ./src/components/LessionCatalog.vue